import { render, staticRenderFns } from "./BillsDetail.vue?vue&type=template&id=dd450640&scoped=true&"
import script from "./BillsDetail.vue?vue&type=script&lang=js&"
export * from "./BillsDetail.vue?vue&type=script&lang=js&"
import style0 from "./BillsDetail.vue?vue&type=style&index=0&id=dd450640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd450640",
  null
  
)

export default component.exports